import { render, staticRenderFns } from "./keyword-documentsearch-result.vue?vue&type=template&id=33aaae7a&scoped=true&"
import script from "./keyword-documentsearch-result.vue?vue&type=script&lang=js&"
export * from "./keyword-documentsearch-result.vue?vue&type=script&lang=js&"
import style0 from "./keyword-documentsearch-result.vue?vue&type=style&index=0&id=33aaae7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aaae7a",
  null
  
)

export default component.exports